/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { REMEMBER_CREDENTIALS_KEY } from './remember-credentials-key';

export function syncCredentialsWithLocalStorage(clusters) {
  const existingData = JSON.parse(localStorage.getItem(REMEMBER_CREDENTIALS_KEY)) || {};

  const newData = clusters
    .filter((cluster) => cluster.authentication === 'CLIENT_CREDENTIALS')
    .reduce((acc, cluster) => {
      const grpcKey = cluster.urls?.zeebeGrpc;

      if (grpcKey) {
        // Preserve existing values or add default ones
        acc[grpcKey] = existingData[grpcKey] || {
          clientId: '',
          clientSecret: '',
          rememberCredentials: false
        };
      }

      return acc;
    }, {});

  localStorage.setItem(REMEMBER_CREDENTIALS_KEY, JSON.stringify(newData));
}
